import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloud = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 207,
	height: 65,
	fill: "none",
	viewBox: "0 0 207 65",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		fillOpacity: .6,
		fillRule: "evenodd",
		d: "M36 31.7c-.7-1.7-1.1-3.4-1.1-5.2C34.9 11.9 59.6 0 90.1 0c25.4 0 46.7 8.2 53.2 19.3a96 96 0 0 1 15.3-1.2c26.6 0 48.2 10.4 48.2 23.3 0 12.2-19.7 22.3-44.6 23.2h-2.8a99.7 99.7 0 0 1-1.5 0H34.6C15.5 64.6 0 57.2 0 48.1c0-9 15.5-16.4 34.6-16.4H36Z",
		clipRule: "evenodd"
	})
});
export default SvgCloud;
